import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';

import WhiteArrowRight from '../../../media/felsv/white_right-arrow_icon.svg';
import { State } from '../../../reducers';
import { actionsGPEditarProducto } from '../../../actions/action-creators';
import { DICCIONARIO } from '../../../constants/Diccionario';
import SearchSelect from '../../../components/Inputs/SearchSelect';
import { BasicLayout } from '../../../modules/Layouts/basicLayout';
import { generalOpenConfirmEdit } from '../../../actions/general.actions';
import { gp_ep_Clear, gp_ep_validacionesEditarProducto } from '../../../actions/gestion-producto/editar-producto/editarProducto.actions';
import TablaAccesosEditarProducto from './components/TablaAccesosEditarProducto';

const EditarProducto = () => {
    const { formProduct, formErrorProduct, productoSeleccionado, modales, sucursalesAsignadas } = useSelector(
    (state: State) => state.gestionProducto.editarProducto
);
    const [precioCambiado, setPrecioCambiado] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const actions = bindActionCreators(actionsGPEditarProducto, dispatch);
    const {unidadesMedida,impuestosProducto, productos:productosCatalogo}= useSelector(
        (state:State) => state.catalogos
    )
    // Limpia formulario al desmontar
   useEffect(() => {
    if (!productoSeleccionado) return;

    window.scroll(0, 0);

    // precio con IVA, sin IVA y cálculo de IVA
    const precioUnitario = parseFloat(productoSeleccionado.precioUnitario) || 0;
    if (precioUnitario > 0) {
        const precioSinIVA = +(precioUnitario / 1.13).toFixed(2);
        const iva = +(precioUnitario - precioSinIVA).toFixed(2);

        actions.gp_ep_FormEditarHandleChangeInput({ target: { name: 'precioUnitario', value: precioUnitario.toString() } } as any);
        actions.gp_ep_FormEditarHandleChangeInput({ target: { name: 'precioSinIVA', value: precioSinIVA.toString() } } as any);
        actions.gp_ep_FormEditarHandleChangeInput({ target: { name: 'iva', value: iva.toString() } } as any);
    }

    // unidad de medida
    actions.gp_ep_FormEditarHandleChangeInput({ 
        target: { name: 'unidadMedida', value: String(productoSeleccionado.unidadMedida || '') } 
    } as any);

    // impuesto distinto al IVA
    actions.gp_ep_FormEditarHandleChangeInput({ 
        target: { name: 'impuestoDistintoAlIVA', value: String(productoSeleccionado.impuestoDistintoAlIVA || '') } 
    } as any);

    // código de producto
    actions.gp_ep_FormEditarHandleChangeInput({ 
        target: { name: 'codigoProducto', value: String(productoSeleccionado.codigoProducto || '') } 
    } as any);

    // descripción
    actions.gp_ep_FormEditarHandleChangeInput({ 
        target: { name: 'descripcion', value: String(productoSeleccionado.descripcion || '') } 
    } as any);
}, [productoSeleccionado]);

const cancelar = () => {
    dispatch(gp_ep_Clear());
    history.push('/gestion-productos/listar-productos');
};


const tieneErrores = () => {
    const erroresExistentes = Object.values(formErrorProduct).some(
        err => typeof err === 'string' && err.trim() !== ''
    );

    const camposVacios =
        !formProduct.codigoProducto?.trim() ||
        !formProduct.descripcion?.trim() ||
        !formProduct.unidadMedida ||
        !formProduct.precioUnitario;

    const descripcionValida = formProduct.descripcion.length <= 80;

    return erroresExistentes || camposVacios || !descripcionValida;
};

const submit = (e:any) => {
  e.preventDefault();
  dispatch(generalOpenConfirmEdit(() => action_submit(e)));
};
const action_submit = async (e: any) => {
  e.preventDefault();

  const tieneErrores = await dispatch<any>(gp_ep_validacionesEditarProducto());
  if (tieneErrores) return; // si hay errores, no continúa

  const productoConSucursales = {
    ...formProduct,
    sucursalesAsignadas: sucursalesAsignadas,
    codigoSucursal: sucursalesAsignadas.join(','),
  };

  dispatch({
    type: 'GESTION_PRODUCTOS_TYPES.EP_SET_SUCURSALES_ASIGNADAS',
    payload: sucursalesAsignadas,
  });

  dispatch({
    type: 'GESTION_PRODUCTOS_TYPES.EP_SET_FORM_PRODUCT',
    payload: productoConSucursales,
  });

  actions.gp_ep_EditarProducto(history, precioCambiado);

};

const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    actions.gp_ep_FormEditarHandleChangeInput(e);

    if (e.target.name === 'descripcion') {
        const valor = e.target.value;
        if (valor.length > 80) {
            actions.gp_ep_AddError({ descripcion: 'La descripción no puede exceder 80 caracteres' });
        } else {
            actions.gp_ep_AddError({ descripcion: '' });
        }
    }

    if (e.target.name === "precioUnitario") {
    setPrecioCambiado(true);
    const precioUnitario = parseFloat(e.target.value) || 0;
    const precioSinIVA = +(precioUnitario / 1.13).toFixed(2);
    const iva = +(precioUnitario - precioSinIVA).toFixed(2);
    actions.gp_ep_FormEditarHandleChangeInput({ target: { name: 'precioSinIVA', value: precioSinIVA.toString() } } as any);
    actions.gp_ep_FormEditarHandleChangeInput({ target: { name: 'iva', value: iva.toString() } } as any);
}

};


const handleUnidadDeMedidaChange = (selected: any) => {
        const value = selected ? selected.value : '';
        const fakeEvent = { target: { name: 'unidadMedida', value } } as React.ChangeEvent<HTMLInputElement>;
        actions.gp_ep_FormEditarHandleChangeInput(fakeEvent);
        actions.gp_ep_ValidacionesFormOnBlur(fakeEvent);
    };

   const handleImpuestoDistintoAlIvaChange = (selected: any) => {
  let value = '';

  if (selected && selected.value !== '') {
        value = selected.value;
    }

    if (!selected || selected.value === '') {
        value = '';
    }

    const fakeEvent = {
        target: { name: 'impuestoDistintoAlIVA', value }
    } as React.ChangeEvent<HTMLInputElement>;

    actions.gp_ep_FormEditarHandleChangeInput(fakeEvent);
    actions.gp_ep_ValidacionesFormOnBlur(fakeEvent);
    if (!selected || selected.value === '') {
        actions.gp_ep_AddError({ impuestoDistintoAlIVA: '' });
    }
};


    return (
        <BasicLayout>
        <div className='header'>
            <button className='back-button w-inline-block' onClick={cancelar}></button>
            <h3 className='h3-titles xl'>Editar Producto</h3>
        </div>
        <div className='separador'></div>
        <div
            id='w-node-_editar-producto'
            className='w-layout-layout bill-section wf-layout-layout'
        >
            <form className="card w-form w-100 mt-16" autoComplete="off" onSubmit={submit}>
            <div className="card-basic w-100">
            <h3 className="card-title l mb-16">Información sucursal</h3>
            <div className="separador" style={{ opacity: '10%' }} />
            <p style={{marginTop: '10px', color: '#555', fontSize: '13.5px', fontWeight: 'normal', lineHeight: '1.5'}}>
            Al editar el precio:
            <br/>
            Si seleccionas <strong>una o varias sucursales</strong>, el cambio se aplicará solo a esas sucursales.
            <br/>
            Si seleccionas <strong>todas las sucursales</strong>, se actualizará el precio base del producto para toda la empresa.
            </p>
            <div className="form-content mt-16">
                <TablaAccesosEditarProducto />
            </div>
            </div>
            </form>
            <form className="card w-form w-100 mt-16" autoComplete="off" onSubmit={submit}>
            <div className="card-basic w-100">
                <h3 className="card-title l mb-16">Información del Producto</h3>
                <div className="separador" style={{ opacity: '10%' }} />
                <div className="form-content mt-16">
                <div className="w-layout-hflex h-inputs">
                    <div className="label-input">
                    <label htmlFor="codigoProducto" className='field-label m'>{DICCIONARIO.CODIGO_PRODUCTO}</label>
                    <input
                        type="text"
                        className="m text-field w-input"
                        name='codigoProducto'
                        placeholder='Código Producto'
                        id='codigoProducto'
                        disabled={false}
                        value={formProduct.codigoProducto}
                        onBlur={(e) => actions.gp_ep_ValidacionesFormOnBlur(e)}
                        onChange={handleChange}
                        maxLength={50}
                    />
                    {formErrorProduct.codigoProducto && <p className='alert s'>{formErrorProduct.codigoProducto}</p>}
                    </div>

                    <div className="label-input">
                    <label htmlFor="descripcion" className='field-label m'>{DICCIONARIO.DESCRIPCION_PRODUCTO}</label>
                    <input
                        type="text"
                        name="descripcion"
                        value={formProduct.descripcion}
                        onChange={handleChange}
                        className="m text-field w-input"
                        onBlur={(e) => actions.gp_ep_ValidacionesFormOnBlur(e)}
                        placeholder={DICCIONARIO.DESCRIPCION_PRODUCTO}
                        maxLength={80}
                    />
                    {formErrorProduct.descripcion && <p className='alert s'>{formErrorProduct.descripcion}</p>}
                    </div>

                    <div className="label-input">
                    <label htmlFor="unidadDeMedida" className='field-label m'>{DICCIONARIO.UNIDAD_DE_MEDIDA}</label>
                    <SearchSelect
                        data={unidadesMedida}
                        keyNameText="valor"
                        keyNameValue="codigo"
                        placeholder="Unidad de medida"
                        value={formProduct.unidadMedida}
                        onChange={handleUnidadDeMedidaChange}
                        name="unidadDeMedida"
                        disabled={false}
                    />
                    {formErrorProduct.unidadMedida && <p className='alert s'>{formErrorProduct.unidadMedida}</p>}
                    </div>
                </div>
                <div className="w-layout-hflex h-inputs">
                    <div className="label-input">
                    <label htmlFor="precioUnitario" className='field-label m'>{DICCIONARIO.PRECIO_UNITARIO}</label>
                    <input
                        type="text"
                        name="precioUnitario"
                        value={formProduct.precioUnitario}
                        onChange={handleChange}
                        className="m text-field w-input"
                        placeholder={DICCIONARIO.PRECIO_UNITARIO}
                        disabled={false}
                    />
                    {formErrorProduct.precioUnitario && <p className='alert s'>{formErrorProduct.precioUnitario}</p>}
                    </div>

                    <div className="label-input">
                    <label htmlFor="precioSinIVA" className='field-label m'>{DICCIONARIO.PRECIO_SIN_IVA}</label>
                    <input
                        type="text"
                        name="precioSinIVA"
                        value={formProduct.precioSinIVA}
                        readOnly
                        className="m text-field w-input"
                        disabled={true}
                    />
                    </div>

                    <div className="label-input">
                    <label htmlFor="iva" className='field-label m'>{DICCIONARIO.IVA}</label>
                    <input
                        type="text"
                        name="iva"
                        value={formProduct.iva}
                        readOnly
                        className="m text-field w-input"
                        disabled={true}
                    />
                    </div>
                </div>
                <div className="w-layout-hflex h-inputs">
                    <div className="label-input">
                    <label htmlFor="impuestoDistintoAlIVA" className='field-label m'>{DICCIONARIO.IMPUESTO_DISTINTO_AL_IVA}</label>
                    <SearchSelect
                        data={[{ idimpuesto: '', descripcion: 'SIN IMPUESTO' }, ...impuestosProducto]}
                        keyNameText="descripcion"
                        keyNameValue="idimpuesto"
                        placeholder={DICCIONARIO.IMPUESTO_DISTINTO_AL_IVA}
                        value={formProduct.impuestoDistintoAlIVA || ''}
                        onChange={handleImpuestoDistintoAlIvaChange}
                        name="impuestoDistintoAlIVA"
                        disabled={false}
                    />
                    </div>
                    <div className="label-input">
                    <label htmlFor="tipoItem" className='field-label m'>{DICCIONARIO.SERVICIO_O_PRODUCTO}</label>
                    <select
                        name="tipoItem"
                        value={formProduct.tipoItem}
                        onChange={handleChange}
                        className="m text-field w-input"
                    >
                        <option value="0">Servicio</option>
                        <option value="1">Producto</option>
                    </select>
                    {formErrorProduct.tipoItem && <p className='alert s'>{formErrorProduct.tipoItem}</p>}
                    </div>
                    <div
                        style={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        }}
                    >
                    </div>
                </div>
                </div>
            </div>

            <div className="separador mt-16" />
            <div className="mt-16 w-100 button-actions" style={{ display: 'flex', justifyContent: 'space-between' }}>
                 <button
                type='button'
                className='m button transparent w-inline-block w-auto'
                onClick={cancelar}
            >
                Cancelar
            </button>
                <button
                type="submit"
                className="m button w-inline-block w-auto"
                disabled={tieneErrores()}
            >
            Actualizar Producto <img src={WhiteArrowRight} alt="Actualizar Producto" />
            </button>
            </div>
            </form>
        </div>
        </BasicLayout>

            )
}

export default EditarProducto;
